import { Box, Paper } from "@mui/material";
import indianNumberFormatter from "../../../../../utils/indianNumberFormatter";

const StateCard = ({ background, title, data }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        // p: "10px",
        width: "150px",

        display: "flex",

        flexDirection: "row",
      }}
    >
      <Box
        sx={{
          background: background,
          width: "50px",
          height: "auto",
        }}
      ></Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingInline: "10px",
          paddingBlock: "5px",
        }}
      >
        <span style={{ fontSize: "12px" }}>{title}</span>
        <span>{indianNumberFormatter(data)}</span>
      </Box>
    </Paper>
  );
};
export default StateCard;
